var scope_0 = require('/opt/build/repo/packages/benefit-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
var scope_1 = require('/opt/build/repo/packages/benefit-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/54aea6998ab0536357d954db95302074.js').default;
var scope_2 = require('/opt/build/repo/packages/benefit-docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c265ae494d40e774fb5963d688cd034d.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    